// ====================================================================
// ziven-core forum modifyDiscussionItem - 帖子列表项改写
// ====================================================================
//
// 整体设计:
//   - desktop 模式: safeExtend(DiscussionListItem, 'infoItems') 末尾追加 reaction summary,
//     走 vendor 顶层 .DiscussionListItem-info 段, mithril 自动管理 dom
//   - mobile 模式: safeExtend(DiscussionListItem, 'mainView') + setInterval + jQuery 注入
//     .DiscussionListItemMobile 段 (沉淀模式, 重构)
//   - 缩略图: safeExtend(DiscussionListItem, 'mainView') desktop 末尾追加 DiscussionThumbnails vnode
//
// (辉哥 15:08 反馈 "登录账号 follow/bookmark 后 ... 还是消失"):
//   之前修法 (L93-101 早 return + always show) 不够, 因为 vendor DiscussionListItem
//   重新 mithril mount 时会抹掉 ziven-core jQuery append 的 .DiscussionListItemMobile 段
//   (包括 .itemShowOptions / .itemStateBadges / .ziven-core-discussion-reaction-summary 等)
//   新 mainView 触发新 setInterval 跑时, 如果 mithril 复用老节点 (in-place update),
//   老 ModifiedDiscussion class 还在老节点, 新 setInterval 走 L93 早 return 跳过 inject
//   → 新 .itemShowOptions 没注入 → "..." 消失
//   修法: 删掉早 return, 每次 setInterval 跑都走完整 inject 流程 (L119-121 empty + L154 append)
//
// (辉哥 15:16 反馈 "不用 setInterval, 把 ... 直接放在那"):
//   试过用 mithril JSX 完整替换 vendor 渲染, 但 vendor <Link class="DiscussionListItem-main"> 包裹
//   ziven-core <DiscussionListItemMobile> div 触发 HTML5 错误 (<a> 内嵌 <div>), 浏览器让 <a> 高度为 0,
//   整个 DiscussionListItemMobile 不显示. 改方案: 退回 setInterval + jQuery 注入, 同时用
//   MutationObserver 兜底监听 vendor DiscussionListItem 内部 .DiscussionListItemMobile 段消失,
//   消失时立即重新 inject (辉哥 iPhone 真机实测"..."消失时立即恢复)
//
// (辉哥 15:16 反馈的 follow-up):
//   MutationObserver 监听 .DiscussionListItem 内部 subtree mutations, 一旦检测到
//   .DiscussionListItemMobile 段被 vendor 抹掉 (follow/bookmark 触发重新 mount),
//   立即重新执行 setInterval 检测 dom mount 流程, 注入 .DiscussionListItemMobile 段
//   配合删 setInterval 早 return 逻辑
//
// (辉哥 15:30 反馈 "登录账号后 ... 没有 + 摘要 Synopsis 没了" 终极根因):
//   症状: mobile 段 .itemExcerpt div 没填内容 (Puppeteer 验证 excerpt 0 字符)
//   调查链: 加 debug 变量后发现 ziven-core 全部 extend hooks (infoItems + mainView + injectMobileContent)
//     一次都没被调 — vendor DiscussionListItem 走默认 prototype method, ziven-core 0 次被 hook
//   终极根因 (辉哥 9/9 c.f.q 部署踩坑再次翻车):
//     server 端 /var/www/bjxy-website/packages/ 下有 13 个 ziven-core .bak17* 残留目录 +
//     1 个老 ziven-core/ (没空格) 全部带 composer.json, flarum ExtensionManager 扫 packages/ 时
//     把每个 bak 目录当独立扩展加载, 14 个 ziven-core 互相覆盖 extend hooks, 最终 0 个 ziven-core
//     自己的 extend 真正生效 (desktop 模式 reaction summary "2" 是 ziven-reactions 副作用, 不是
//     ziven-core DiscussionReactionSummary 组件输出)
//   修法:
//     1) server 端清理: rm -rf ziven-core .bak17* (13 个) + rm -rf ziven-core (没空格老目录)
//     2) cd /var/www/bjxy-website && php flarum cache:clear (让 flarum 重新扫 packages/)
//     3) [HISTORICAL, r.7 (辉哥 9/16 16:18 拍板 B) 彻底回滚] ziven-core mobile 段 .itemExcerpt 自己
//        从 discussion.firstPost().contentPlain() 取 175 字符截断填入, 跟 vendor desktop 段
//        .Synopsis-excerpt 内容一致 — 后来发现这越权 (fof-synopsis disabled 状态不应 ziven-core 私自填,
//        应完全走 fof-synopsis)
//   实战教训 (任何 ziven 扩展部署 SOP):
//     - 任何 ziven 扩展嵌套 .bak* / .old / 残留目录都要清, flarum ExtensionManager 扫所有 packages/
//       下 flarum-extension 类型子目录, 会被当独立扩展加载, 互相覆盖 extend hooks, 最终 0 个
//       ziven 自己的 extend 真正生效
//     - 部署踩坑: 19+ 个 commit 反复返工实际 ziven-core extend 0 次被调, Puppeteer
//       看到的"成功"是 ziven-reactions 副作用 — 任何 commit Puppeteer 验证异常, 第一步先查
//       server 端 packages/ 残留目录, 别再盲目改代码
//     - 验证 ziven-core extend 是否生效的 debug 方法: window.__zivenInjectCalls++ 跟 vendor
//       mainView / infoItems 调用计数对比
//   适用: 任何 ziven 扩展部署前必查 server 端 packages/ 嵌套 .bak* 残留
//
// (辉哥 9/16 16:18 拍板 B 选项 — 彻底回滚 r.1 修法 3):
//   彻底删除 ziven-core mobile 段所有 excerpt 相关代码 (const itemExcerpt / 空 div / click handler /
//   firstPost().contentPlain() 截断填 / remove()), 让摘要完全走 fof-synopsis. ziven-core 私自填
//   vendor .item-excerpt 是越权 (vendor mobile 模式默认不渲染 excerpt; 启用 fof-synopsis 后才走
//   fof-synopsis 自己的渲染逻辑)
//   删 5 处:
//     - line 289  const itemExcerpt = discussionContainer.find('.item-excerpt')
//     - line 312  "<div class='itemExcerpt'></div>" HTML (mobile 段 jQuery append 阶段)
//     - line 335-337  .itemExcerpt click handler
//     - line 357-367  excerpt 填充 firstPost().contentPlain() 截断 175 整段
//     - line 369  itemExcerpt.remove()
//   期望效果:
//     - mobile (iPhone Safari UA): .DiscussionListItem 内不再有 .itemExcerpt 渲染 (vendor mobile 模式
//       默认不渲染 excerpt, ziven-core 也不再私自 append 填), 即便 fof-synopsis disabled 也是
//     - desktop (默认 desktop UA): fof-synopsis disabled 时, .Synopsis-excerpt 不显示 (期待 V 测验证后
//       单独再启 fof-synopsis 拿摘要)
//   实战教训 (跨扩展职责不要越权):
//     - ziven-core 改 vendor 元素 (vendor 没有显式 hook 给 ziven-core) 是越权
//     - 摘要应完全交给 fof-synopsis / 类似 vendor 协作扩展, ziven-core 只做自己负责的 mobile 段重组
//     - commit message "回滚锚 H1": 走不通时回稳定版 (r.7 是 final attempt, 不再返工)
//   适用: 任何 ziven 扩展跟 vendor Flarum 2.0 协作元素交互场景 (vendor 没显式 hook 不要碰)
//
// (辉哥 9/16 18:21 拍板 B 方案 — 跟 r.16 互补修复):
//   r.16 (commit 85893e6) 删 mobile 段 excerpt 相关代码 (itemExcerpt const + 空 div HTML + fill text +
//   remove), 但 less/forum.less L496-498 `@media @phone { .DiscussionListItem-main { display: none } }`
//   没改 → 即便 fof-synopsis 启用 vendor .DiscussionListItem-main 内的 .item-excerpt (含 .Synopsis-excerpt)
//   div 跟 .DiscussionListItem-main 一起被隐藏, mobile 端看不到摘要.
//   r.17 B 方案 (辉哥 18:21 拍板, 不再越权回 r.7 之前的 "ziven-core 自己填 firstPost().contentPlain()"
//   越权路线, 摘要完全交给 fof-synopsis, ziven-core 只搬 vendor 渲染的 div HTML):
//     1) 恢复 const itemExcerpt = discussionContainer.find('.item-excerpt') (vendor fof-synopsis 渲染的
//        .Synopsis-excerpt 在 .item-excerpt 容器内)
//     2) jQuery append .DiscussionListItemMobile > .itemMain 加 <div class='itemExcerpt'></div> 容器
//        (位置: ThumbnailWrap 之后, itemReply 之前 — 视觉上 thumbnails + tags 之间, 符合缩略图 +
//        摘要 + last reply + 标签 footer 阅读顺序)
//     3) clone itemExcerpt.children() (vendor fof-synopsis 渲染的 .Synopsis-excerpt div) 到
//        ziven-core .DiscussionListItemMobile .itemExcerpt 容器, 让 mobile user 看到 fof-synopsis 摘要
//     4) itemExcerpt.remove() 删 vendor 原位 (避免 DOM 噪音 + 防止 mobile mode toggle 后残影,
//        vendor .DiscussionListItem-main 已 display: none 即使保留也不可见)
//   CSS: less/forum.less L573 `.itemExcerpt, .Synopsis-excerpt { -webkit-line-clamp: 3; font-size: .85rem;
//   color: #a2a5b9; }` 已统一两个选择器样式, 搬进来后视觉一致 (3 行截断 + 0.85rem 字号 + 灰色)
//   期望效果:
//     - mobile (iPhone Safari UA): .DiscussionListItemMobile > .itemMain > .itemExcerpt 内显示
//       vendor .Synopsis-excerpt div (fof-synopsis 启用时, 摘要文本); fof-synopsis disabled 时
//       .itemExcerpt 容器为空 (不显示, 跟 r.16 行为一致)
//     - desktop (默认 desktop UA): vendor .item-excerpt 走 vendor 路径, ziven-core 不动 (less L498
//       .DiscussionListItem-main { display: none } 只在 @phone, desktop 模式整段可见)
//     - DB bjxy_user_followers 不变 (本任务不碰 follow)
//   实战教训 (跟 r.16 互补):
//     - r.16 删代码 + r.17 搬代码 = 互补修复: r.16 阻止 ziven-core 越权私自填, r.17 让 fof-synopsis
//       渲染的摘要在 mobile 可见 (绕过 vendor .DiscussionListItem-main 的 mobile 隐藏)
//     - 跨扩展协作: ziven-core 改 vendor 渲染好的元素 → clone DOM 而不是 fill text (fill text 越权,
//       clone DOM 利用 vendor 现有渲染, 不重复工作)
//     - vendor mobile 隐藏但 vendor data 还在: 隐藏 + 数据在 ≠ 可见, 需要把数据搬到 ziven-core 容器
//   回滚锚 H1: r.17 走不通立刻 `git checkout H1` 回到稳定版 (commit 85893e6 + tag H1)
//   适用: 任何 ziven 扩展 mobile 段需用 vendor desktop-only 渲染内容场景 (clone 而非 fill)
// ====================================================================
import { extend as _rawExtend, override as _rawOverride } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionThumbnails from './components/DiscussionThumbnails';
import DiscussionReactionSummary from './components/DiscussionReactionSummary';
// r.9d (辉哥 2026-09-23 09:53 看源码后反错 r.9c): 回复者头像放到 mobile 段 .itemHeaderAvatar,
//   跟 firstPost author 头像同位置. 用 vendor Avatar 组件构造头像 vnode → m.render 转 DOM → jQuery append.
import Avatar from 'flarum/common/components/Avatar';
export default function modifyDiscussionItem() {
  // (辉哥 9/17 16:47 派 Coder 修): webpack DCE 把 const helper globals 去掉,
  // 改用 function declaration 让 helper 名字在函数体内可用
  function safeExtend(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeExtend) {
      console.warn('[ziven-core] safeExtend helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeExtend(targetOrClass, method, fn);
  }
  function safeOverride(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeOverride) {
      console.warn('[ziven-core] safeOverride helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeOverride(targetOrClass, method, fn);
  }

  // ── 全部失败教训 (辉哥 07:42 iPhone 真机 r.12.h.3 FAIL) ────────
  // r.12.h (Object.defineProperty 拦截 showing) → r.12.h.1 (jQuery delegate) → r.12.h.2
  //   (touchstart + mousedown) → r.12.h.3 (capture phase addEventListener) 全部 iPhone 真机 FAIL
  //
  // 终极修法 (辉哥 07:42 iPhone 真机 r.12.h.3 FAIL 真根因 + 终极方案):
  //   调查链 (Coder web_fetch vendor Flarum v2.0.0-rc.8 源码):
  //     1) vendor DiscussionListItem.tsx L138-149: 触摸设备下 controls 段是 vendor Dropdown,
  //        buttonClassName="... Slidable-underneath Slidable-underneath--right"
  //     2) vendor slidable.js L99-118: 触摸设备 touchend, 滑动超 50px → activate($underneathRight)
  //        → $underneathRight.click() (jQuery click on vendor .Dropdown-toggle, 因为 buttonClassName
  //        含 .Slidable-underneath--right)
  //     3) vendor Dropdown.tsx L189: toggle button 有 `data-toggle="dropdown"`, Bootstrap 4 dropdown
  //        在 document ready 时自动 init click handler on `[data-toggle="dropdown"]` elements
  //     4) vendor Dropdown.tsx L77-118 oncreate: 监听 controls `shown.bs.dropdown` 事件 →
  //        this.showing = true + m.redraw() → mithril view 加 'open' class → menu 弹
  //     5) vendor Flarum 2.0 触摸设备 CSS (推测, 待 server 验证): `@media (any-hover: none)
  //        { .Dropdown-toggle { display: none } }`, 让触摸设备用 Slidable 滑动代替点击 toggle
  //
  //   真根因 (iOS Safari WebKit 安全行为):
  //     - iOS Safari WebKit 已知: `display: none` element 的 programmatic click (jQuery .click() /
  //       .trigger('click') / el.dispatchEvent(new MouseEvent('click'))) **静默忽略**
  //     - 这是 WebKit 安全机制, 防止 user gesture 模拟, 防止 XSS 隐藏按钮被点
  //     - visibility: hidden / opacity: 0 元素的 programmatic click 正常 fire
  //     - pointer-events: none 元素 programmatic click 静默忽略
  //
  //   之前 r.12.h / h.1 / h.2 / h.3 都基于 jQuery $toggle.click() / $toggle.trigger('click') 模拟
  //     vendor .Dropdown-toggle click → iOS Safari 触摸设备 display: none 静默忽略 → 全部 listeners
  //     (capture phase / bubble phase / target phase) 都不跑 → menu 不弹
  //   关键洞察: r.12.h.3 capture phase addEventListener 在 iOS Safari 触摸设备下根本不会被调用,
  //     因为 simulated click 不触发任何 event dispatch. Puppeteer desktop 模拟验证不到
  //     (desktop WebKit 对 display: none element programmatic click 行为不同)
  //
  //   终极修法 (不依赖 vendor .Dropdown-toggle click):
  //     A) 撤掉所有 r.12.h / h.1 / h.2 / h.3 拦截 (Object.defineProperty showing + capture phase
  //        addEventListener + jQuery delegate), 全部作废
  //     B) vendor mithril Dropdown 自身的 `this.showing = true` 走原型 setter, 不拦截
  //        (vendor Dropdown.tsx L78 是 in-class `this.showing = true`, 走 prototype 上 showing)
  //     C) 用 MutationObserver 监听 vendor .DiscussionListItem-controls className 变化
  //        - 看到 'open' className 加 + 没 ziven-core flag → vendor auto-open (Slidable 滑动 /
  //          内部 dispatch) → 立即 fire 'hidden.bs.dropdown' 关闭
  //        - 看到 'open' className 加 + 有 ziven-core flag → ziven-core 主动触发 → 跳过
  //     D) ziven-core .itemShowOptions-btn click handler (L501-513): 改 `$(controls).trigger(
  //        'shown.bs.dropdown')` + 设 flag, 走 vendor Dropdown 'shown.bs.dropdown' listener 直接设
  //        this.showing=true → mithril redraw → menu 弹. jQuery trigger('shown.bs.dropdown') 是
  //        custom event, 走 jQuery simulate event flow on controls container, 不依赖 .Dropdown-toggle
  //        click, 不受 iOS Safari display: none 静默忽略限制
  //
  //   实战教训 (任何 ziven 扩展跟 vendor Flarum 2.0 触摸设备交互):
  //     - iOS Safari WebKit `display: none` element programmatic click → 静默忽略 (安全机制)
  //     - 不能依赖 vendor .Dropdown-toggle 模拟 click 触发 vendor Dropdown, 必须走 vendor event API
  //     - jQuery `trigger('custom-event')` on vendor container 是 jQuery simulate, 不受 iOS Safari
  //       display: none 限制, 是触发 vendor custom event listener 的安全方式
  //     - Puppeteer desktop 模拟验证不到 iOS Safari 触摸设备 display: none click 静默忽略行为,
  //       必须辉哥 iPhone 真机手测确认
  //   适用: 任何 ziven 扩展跟 vendor Flarum 2.0 触摸设备 + display: none 元素交互场景
  safeExtend(Dropdown, 'oncreate', function (val, vnode) {
    const dropdown = this;
    const $this = dropdown.$();
    if (!window.MutationObserver || !$this[0]) return;
    // 只对 vendor .DiscussionListItem-controls 段生效 (避开导航栏的 Dropdown)
    if (!$this.hasClass('DiscussionListItem-controls')) return;

    // 监听 className 变化: vendor 'open' className 加上时, 检查 flag
    // - 没 flag → vendor auto-open (Slidable 滑动 / 内部 dispatch) → 立即 fire 'hidden.bs.dropdown' 关闭
    // - 有 flag → ziven-core 主动触发 → 跳过
    const observer = new MutationObserver(() => {
      if (dropdown.showing && $this.attr('data-ziven-user-opened') !== 'true') {
        $this.trigger('hidden.bs.dropdown');
      }
    });
    observer.observe($this[0], {
      attributes: true,
      attributeFilter: ['class']
    });

    // 监听 vendor 'hidden.bs.dropdown' 事件, 清除 ziven-core flag (下次需要新 flag)
    $this.on('hidden.bs.dropdown.zivenCoreR12h4', () => {
      $this.removeAttr('data-ziven-user-opened');
    });
  });

  // ── (辉哥 00:00 iPhone 真机反馈 "「ziven-core」在运行时发生错误" 终极修法):
  //   vendor Flarum 2.0 v2.0.0-rc.8 slidable.js reset() 函数在 complete callback 调
  //     r.hide(); n.hide(); (r=$underneathLeft, n=$underneathRight, closure 变量),
  //   但 user 从未触摸 LI 时 r/n 是 undefined, vendor code 调 undefined.hide() 抛
  //     "TypeError: Cannot read properties of undefined (reading 'hide')"
  //   修法: ziven-core 改 vendor DiscussionListItem.oncreate 钩子, 在 slidable(this.element) 拿到
  //   instance 后, monkey-patch slidableInstance.reset() 加 null check
  //   实际: 直接 hook vendor 'hidden.bs.dropdown' 事件 listener, 在 slidableInstance.reset() 之前
  //   跑 ziven-core 的 try/catch, 拦住 vendor 的 undefined.hide() 错误
  // 实战教训: vendor Flarum 2.0 v2.0.0-rc.8 有 known bug, closure 变量 $underneathLeft/Right
  //   在 user 未触摸时未初始化. vendor DiscussionListItem.oncreate 绑 'hidden.bs.dropdown'
  //   事件调 slidableInstance.reset() → undefined.hide() 报错. vendor 官方未发 hotfix
  safeExtend(DiscussionListItem, 'oncreate', function (val, vnode) {
    // vendor 原 oncreate 已经跑 (设 this.element + vendor Slidable 初始化)
    // vendor L237 绑 'hidden.bs.dropdown' 事件 → slidableInstance.reset() 抛 undefined.hide()
    // 我们重新绑一个 listener, 早于 vendor 的 listener 跑, 用 m.redraw 替代 vendor reset
    setTimeout(() => {
      this.$('.DiscussionListItem-controls').off('hidden.bs.dropdown');
      this.$('.DiscussionListItem-controls').on('hidden.bs.dropdown', () => {
        try {
          // vendor Slidable reset 内部调 undefined.hide() 抛错
          // 跳过 vendor reset, 直接 m.redraw 让 mithril Dropdown 重新渲染
          m.redraw();
        } catch (e) {
          console.warn('[ziven-core] patched vendor slidable.reset() error:', e.message);
        }
      });
    }, 0);
  });

  // ── share 按钮: ziven-core 自己也 extend DiscussionControls.userControls 注册 ──
  // 辉哥 9/10 23:45 反馈 "现在进入帖子列表页面会自动弹出"…"的菜单, 菜单里分享不要用 inject 模式,
  //   用 extend 方式加, 类似 fof-pwa addShareControls (extend DiscussionControls, 'userControls', ...)"
  // 不用 inject 方式, 走 mithril 2.x extend hook 直接注册到 DiscussionControls.userControls
  // 关键: 跟辉哥给的 fof-pwa addShareControls 代码一样, items.add key='share', priority -1, 不限制登录态
  //   mithril ItemList.add 同 key 不会去重, 两个 'share' 都会在 menu 里. ziven-core 跟 fof-pwa 一样, 双保险
  //   即使 fof-pwa 钩子没跑, ziven-core 这个 share 也会渲染
  //   onclick 调 navigator.share (PWA API, iPhone Safari 触发原生 share sheet)
  // (辉哥 23:45): 跟辉哥示例完全对齐 — key 'share' (不是 'zivenCoreShare'), priority -1
  safeExtend(DiscussionControls, 'userControls', function (items, discussion) {
    items.add('share', m(Button, {
      icon: "fas fa-share-square",
      onclick: async () => {
        try {
          await navigator.share({
            title: discussion.title(),
            url: app.route.discussion(discussion)
          });
        } catch (err) {
          // 用户取消分享, silent
          console.log('[ziven-core] share cancelled:', err.message);
        }
      }
    }, app.translator.trans('ziven-community-core.forum.share_button') || '分享'), -1);
  });

  // ── desktop 模式: reaction 表情 + 总数 ─────────────────────
  // safeExtend(DiscussionListItem, 'infoItems') 在 vendor infoItems 末尾追加
  // reaction summary item. priority -80 排 views (-50) 之后, excerpt (-100) 之前
  safeExtend(DiscussionListItem, 'infoItems', function (items) {
    if (window.zivenCore && typeof window.zivenCore.isMobile === 'function' && window.zivenCore.isMobile()) {
      return; // mobile 模式不挂, 改在 mobile 段 jQuery 渲染
    }
    items.add('zivenReactionsSummary', m(DiscussionReactionSummary, {
      discussion: this.attrs.discussion
    }), -80);
  });

  // ── desktop 模式: 缩略图 vnode 注入 ────────────────────────────
  // safeExtend(DiscussionListItem, 'mainView') 末尾追加 vnode, mithril 自动 mount
  safeExtend(DiscussionListItem, 'mainView', function (vnode) {
    const discussion = this.attrs.discussion;
    if (!discussion) return;
    if (window.zivenCore && typeof window.zivenCore.isMobile === 'function' && window.zivenCore.isMobile()) {
      return; // mobile 模式不挂, 改在 mobile 段 jQuery 注入 (路线)
    }
    if (!vnode.children) vnode.children = [];
    if (Array.isArray(vnode.children)) {
      vnode.children.push(m(DiscussionThumbnails, {
        discussion
      }));
    } else {
      vnode.children = [vnode.children, m(DiscussionThumbnails, {
        discussion
      })];
    }
  });

  // ── mobile 模式: jQuery 整卡片重组 (沉淀) + oncreate 兜底 ─
  // 修法 (MutationObserver 监听 vnode.dom subtree) 走不通:
  //   登录账号后 vendor 重新 mount 整个 .DiscussionListItem, vnode.dom 本身被替换,
  //   老的 MutationObserver 闭包还在 old dom 上, 不再生效, 注入段被抹掉后没补回
  // 修法: 改走 mithril oncreate 钩子, vendor 每次 mount (初始 / 登录后重新 mount
  //   / follow/bookmark 触发) 都走 ziven-core oncreate 重新 inject, 跟 mithril 生命周期对齐
  // 辉哥 9/10 16:00 反馈 "登录账号后 ... 还是没有" 终极修法
  safeExtend(DiscussionListItem, 'mainView', function (vnode) {
    if (!window.zivenCore || typeof window.zivenCore.isMobile !== 'function' || !window.zivenCore.isMobile()) {
      return; // desktop 模式不处理
    }
  });
  safeExtend(DiscussionListItem, 'oncreate', function (vnode) {
    if (!window.__zivenOncreateCalls) window.__zivenOncreateCalls = 0;
    window.__zivenOncreateCalls++;
    if (!window.zivenCore || typeof window.zivenCore.isMobile !== 'function' || !window.zivenCore.isMobile()) {
      return; // desktop 模式不处理
    }
    // 终极修法:
    //   - 改走 mithril oncreate 钩子 (跟 vendor 每次 mount 对齐)
    //   - 不用 vnode.dom (mithril 2.x Vnode 没有 dom 字段), 用 this.element (vendor Component
    //     L74 super.oncreate(vnode) 设 this.element = vnode.dom)
    //   - inject 到 vnode.dom.parentElement (LI 父级), 因为 vendor DiscussionListItem 是
    //     <div class="DiscussionListItem"> 作为 LI 的 child, mithril 重渲染 LI 时会重建
    //     内部所有 children, ziven-core 注入段跟着重建
    //   - setTimeout 0 把 inject 推到下一个 tick, 确保 vendor DiscussionListItem-author/main/stats 都已经 mount
    // 辉哥 9/10 16:00 反馈 "登录账号后 ... 还是没有" 终极修法
    const _this = this;
    setTimeout(() => {
      const dom = this.element; // vendor Component.oncreate: this.element = vnode.dom
      if (!dom) return;
      const $li = $(dom).parent();
      if ($li.length === 0) return;
      $li.addClass('ModifiedDiscussion');
      if ($li.find('.DiscussionListItemMobile').length === 0) {
        injectMobileContent($li, _this.attrs.discussion);
        $li.find('.itemShowOptions').show();
      }
    }, 0);
  });
}

// mobile 段 jQuery inject 逻辑 (从旧版抽出来)
function injectMobileContent(discussionContainer, discussion) {
  var _discussion$attribute;
  // (辉哥 9/16 18:21 拍板 B): 恢复 vendor .item-excerpt const (r.16 删了)
  //   B 方案: ziven-core mobile 段不写摘要文本, 摘要走 fof-synopsis, mobile 段只搬 vendor 渲染的
  //   .Synopsis-excerpt div HTML 搬进 ziven-core .DiscussionListItemMobile > .itemExcerpt 容器.
  //   vendor .DiscussionListItem-main 在 mobile mode 下 display: none (less L496-498), 包含的
  //   .item-excerpt (含 .Synopsis-excerpt) 一起被隐藏. 移到 ziven-core 自己的容器才能看到.
  const itemExcerpt = discussionContainer.find('.item-excerpt');
  const itemTags = discussionContainer.find('.item-tags');
  const itemTitle = discussionContainer.find('.DiscussionListItem-title');
  const itemReply = discussionContainer.find('.item-terminalPost > span');
  const itemAuthor = discussionContainer.find('.DiscussionListItem-author');
  const itemBadges = discussionContainer.find('.DiscussionListItem-badges');
  const imageCount = discussion.attribute('imageCount') || 0;
  const imageList = discussion.attribute('imageList') || [];
  const commentCount = Math.max(0, ((_discussion$attribute = discussion.attribute('commentCount')) != null ? _discussion$attribute : 0) - 1);
  const tags = discussion.tags() || [];
  discussionContainer.find('.DiscussionListItem-badges').hide();

  // (辉哥 9/21 21:10 拍板): 传 discussion 让 renderHtml 判偶数 ID 加 --alt class
  //   desktop 模式走 DiscussionThumbnails.jsx view() → renderHtml(imageList, imageCount, discussion)
  //   mobile 模式走这里 (DiscussionListItemMobile.jsx 是死代码, 实际渲染全在 modifyDiscussionItem.js)
  //   同一份 renderHtml 静态方法保证 desktop + mobile 偶数 ID 帖统一改 alt 布局
  const mobileThumbnailsHtml = DiscussionThumbnails.renderHtml(imageList, imageCount, discussion);
  discussionContainer.append("<div class='DiscussionListItemMobile'>" + "<div class='itemMain'>" + "<div class='itemTitleRow'>" + "<div class='itemTitle'></div>" + "<div class='itemShowOptions'></div>" + "</div>" + "<div class='DiscussionListImageThumbnailWrap'>" + mobileThumbnailsHtml + "</div>" +
  // (辉哥 9/16 18:21 拍板 B): 恢复 .itemExcerpt 容器 (r.16 删了)
  //   位置: thumbnails 之后, last reply 之前 (视觉上 thumbnails + tags 之间)
  "<div class='itemExcerpt'></div>" + "<div class='itemReply'>" + "<div class='itemHeaderAvatar'></div>" + "<span class='ziven-core-discussion-reaction-summary'></span>" + "</div>" + "</div>" + "<div class='itemFooter'>" + "<div class='itemStateBadges'></div>" + "<div class='info'><i class='fa-solid fa-message'></i>" + commentCount + "</div>" + "</div>" + "</div>");
  discussionContainer.find('.DiscussionListImageThumbnailWrap').on('click', function (e) {
    e.stopPropagation();
    m.route.set(app.route.discussion(discussion));
  });

  // itemTitle click handler
  discussionContainer.find('.itemTitle').on('click', function () {
    discussionContainer.find('.DiscussionListItem-main')[0].click();
  });
  if (commentCount === 0) {
    // r.9d (辉哥 2026-09-23 09:53 拍板 A): 没回复 — firstPost author 头像 clone 放 .itemHeaderAvatar (现有逻辑)
    //   clone vendor `.DiscussionListItem-author` (含 Link + Avatar), vendor `.DiscussionListItem-author`
    //   在 DOM 中 hidden (vendor mobile 模式 .DiscussionListItem-main { display: none }), 但 clone
    //   出来的 DOM 内部 `.Avatar` 仍能匹配 ziven-core forum.less L624 `.DiscussionListItem-author .Avatar { --size: 16px }`
    discussionContainer.find('.itemHeaderAvatar').append(itemAuthor.clone());
  } else {
    // r.9d (辉哥 2026-09-23 09:53 拍板): 有回复 — lastPostedUser 头像 (回复者) 放 .itemHeaderAvatar
    //   跟 firstPost author 头像同位置. 自顶自答 (lastPostedUser == firstPost author) 时也用 lastPostedUser
    //   (实际是同一个 user 对象, 头像 src 一致, 但走 lastPostedUser 路径更语义化)
    //   修法: 走 vendor Avatar 组件构造 vnode → m.render 转 DOM element → jQuery append
    //   wrap `.DiscussionListItem-author` div 让 ziven-core forum.less L624 `.DiscussionListItem-author .Avatar { --size: 16px }` 命中
    //   (跟现有 firstPost author 路径结构一致, 视觉 16x16 头像)
    const lastPostedUser = discussion.lastPostedUser();
    if (lastPostedUser) {
      const avatarNode = m(Avatar, {
        user: lastPostedUser,
        loading: "lazy"
      });
      // r.9d 修法实测: mithril m.render 必须传 root element (派活 spec 示例漏了, m.render(vnode) 返回 null/empty).
      //   vendor Flarum 2.0 Fragment.ts L51 用 m.render(document.body, vnode) 模式 — 我们用临时 div 当 root, 拿 firstChild.
      const tmpRoot = document.createElement('div');
      m.render(tmpRoot, avatarNode);
      const avatarDom = tmpRoot.firstChild;
      if (avatarDom) {
        const $wrapper = $('<div class="DiscussionListItem-author"></div>').append(avatarDom);
        discussionContainer.find('.itemHeaderAvatar').append($wrapper);
      }
    }
  }

  // trim username 父 span 前导空格
  const itemReplyClone = itemReply.clone();
  itemReplyClone.find('span').each(function () {
    const tn = this.firstChild;
    if (tn && tn.nodeType === 3) {
      tn.nodeValue = tn.nodeValue.replace(/^\s+/, '');
    }
  });
  discussionContainer.find('.itemReply').append(itemReplyClone);

  // 把 vendor title 文本 append 到 ziven-core .itemTitle div (沉淀)
  discussionContainer.find('.itemTitle').append(itemTitle.text());
  itemTitle.remove();
  itemReply.remove();
  $('.DiscussionListItem-count').remove();
  $('.item-discussion-views').remove();
  itemTags.remove();

  // (辉哥 9/16 18:21 拍板 B): mobile 段把 vendor .item-excerpt (fof-synopsis 渲染
  //   的 .Synopsis-excerpt div) HTML 搬进 .DiscussionListItemMobile > .itemExcerpt 容器.
  //   ziven-core 不写摘要文本, 摘要完全走 fof-synopsis. mobile 段只搬 vendor 渲染好的 div HTML.
  //   vendor .item-excerpt 在 vendor .DiscussionListItem-main (mobile mode display: none) 内,
  //   整段被隐藏, clone 出来到 ziven-core 自己的容器才能让 mobile user 看到 fof-synopsis 摘要.
  //   位置参考: 缩略图 + tags 之间 (itemTitleRow → ThumbnailWrap → itemExcerpt → itemReply → footer)
  //   视觉: 标题 → 缩略图 → 摘要 → 最后回复 → 标签/评论数 footer
  //   CSS: less forum.less L573 `.itemExcerpt, .Synopsis-excerpt` 已统一样式 (3 行截断 + 字号 .85rem)
  if (itemExcerpt.length) {
    // .item-excerpt 子节点 (vendor fof-synopsis 渲染的 .Synopsis-excerpt div + 文本节点等)
    const $vendorExcerptContent = itemExcerpt.children().clone();
    if ($vendorExcerptContent.length) {
      discussionContainer.find('.DiscussionListItemMobile .itemExcerpt').append($vendorExcerptContent);
    }
    // 删 vendor 原位 .item-excerpt (vendor .DiscussionListItem-main 已 display: none 隐藏,
    // 但删掉避免 DOM 噪音 + 防止 mobile mode toggle 后原位残影)
    itemExcerpt.remove();
  }

  // tags 移到 itemFooter 段 (沉淀, 保留)
  //   footer 段 flex layout: tag 在最左, .itemStateBadges 跟 .info 在最右
  //   改法: tag margin-right: auto 把订阅/收藏/评论数推最右 (辉哥 18:55 反馈 "完全居右")
  const $tagLabel = itemTags.find('.TagsLabel').clone();
  $tagLabel.css('margin-right', 'auto');
  discussionContainer.find('.itemFooter').prepend($tagLabel);

  // fa-ellipsis 兜底按钮 append 到 .itemShowOptions 段
  // 辉哥 9/10 16:37 反馈 "如果不收藏或关注帖子的话, ... 就能展示出来, 如果关注过或者收藏过的话, ... 就会消失"
  //   根因: 之前 hide 逻辑 (if itemBadges li > 0 display:none) 残留, vendor
  //   DiscussionListItem-badges 段 follow/bookmark 后会加 1 个 li (订阅/收藏 badge),
  //   ziven-core 跟着 hide "..." 按钮
  // 修法: 删掉 itemBadges 联动 hide, always show "..." 按钮
  // 修法 : 辉哥 9/10 21:57 反馈 "列表页点 ... 没分享, 进帖子返回就有"
  //   根因: ziven-core inject 段 setTimeout 100ms 触发 vendor button.Dropdown-toggle.click()
  //   但 vendor 渲染 controls 段有时序问题 (初始 DiscussionListItem view() 跑时 controls
  //   数组可能是空, 进过帖子页后 mithril 重 mount 才 render controls)
  // 修法 : 辉哥 9/10 22:15 反馈 "打开列表自动弹 ... 菜单, 没分享"
  //   根因: MutationObserver 触发太早, 找到第一个 button.Dropdown-toggle
  //   是导航栏的 (不是 vendor DiscussionListItem-controls 段的), 触发后弹出导航栏菜单
  //   修法: 精确找 vendor .DiscussionListItem-controls button.Dropdown-toggle
  //         (而不是所有 dropdown-toggle, 避开导航栏的)
  //         + 把 bind click 跟 MutationObserver 拆分, observer 只看是不是出现 controls 段,
  //         出现后才绑 click handler (而不是立即 click)
  // 修法 (全部 iPhone 真机 FAIL, 辉哥 07:42 反馈):
  //   上面 tryClickVendorToggle / findVendorControlsToggle / MutationObserver find toggle / 兜底
  //   3s / $options.on('click', ...) 全部基于 jQuery $toggle.click() 模拟 vendor .Dropdown-toggle
  //   click. iOS Safari WebKit 触摸设备下 vendor .Dropdown-toggle 是 `display: none` (vendor less
  //   @media any-hover: none), jQuery .click() / .trigger('click') / el.dispatchEvent(new MouseEvent)
  //   on display: none element **静默忽略**. 全部 4 轮返工都失效.
  // 修法 (终极修法, 辉哥 07:42 反馈 r.12.h.3 FAIL 真根因 + 终极方案):
  //   撤掉 tryClickVendorToggle / findVendorControlsToggle / MutationObserver find toggle / 兜底 3s
  //   全部作废. 改用 jQuery trigger('shown.bs.dropdown') 直接 fire vendor Dropdown 'shown.bs.dropdown'
  //   event on vendor .DiscussionListItem-controls 容器 + 设 flag (data-ziven-user-opened='true'),
  //   走 vendor Dropdown oncreate L77 监听的 'shown.bs.dropdown' listener 直接设 this.showing=true
  //   + m.redraw() → mithril view 加 'open' class → menu 弹
  //   关键: jQuery trigger('shown.bs.dropdown') 是 custom event 走 jQuery simulate event flow on
  //   controls container (不是 .Dropdown-toggle), 不受 iOS Safari display: none 静默忽略限制.
  //   ziven-core extend Dropdown.oncreate 段 (顶部 L142+) MutationObserver 监听 .open className:
  //     - 看到 'open' + 没 flag → vendor auto-open (Slidable 滑动) → fire 'hidden.bs.dropdown' 关闭
  //     - 看到 'open' + 有 flag → ziven-core 主动触发 → 跳过
  discussionContainer.find('.itemShowOptions').append('<div class="itemShowOptions-btn"><i class="fa-solid fa-ellipsis"></i></div>');
  const $options = discussionContainer.find('.itemShowOptions');
  const $dc = discussionContainer;
  // r.12.h.4 终极修法: ziven-core .itemShowOptions-btn click handler 改
  //   不调 jQuery $toggle.click() 模拟 vendor .Dropdown-toggle click (iOS Safari 静默忽略)
  //   改调 jQuery $controls.trigger('shown.bs.dropdown') 直接 fire vendor 'shown.bs.dropdown' event
  //   on vendor .DiscussionListItem-controls 容器 + 设 flag, 走 vendor Dropdown oncreate L77 监听
  //   器直接设 this.showing=true → mithril redraw → menu 弹
  $options.off('click').on('click', function (e) {
    e.stopPropagation();
    // 找 vendor .DiscussionListItem-controls 容器 (不是 toggle button, toggle 在触摸设备下 display: none)
    const $controls = $dc.find('.DiscussionListItem-controls').first();
    if (!$controls.length) return;
    // 设 flag (ziven-core 主动触发, ziven-core 顶部 extend Dropdown.oncreate 段 MutationObserver
    // 看到 'open' className 加时检查 flag, 有 flag 跳过拦截, 允许 menu 弹)
    $controls.attr('data-ziven-user-opened', 'true');
    // 触发 vendor 'shown.bs.dropdown' listener → vendor 跑 this.showing=true + m.redraw()
    // → mithril view 加 'open' class → menu 弹
    // jQuery trigger 是 custom event, 走 jQuery simulate event flow on controls 容器,
    // 不依赖 vendor .Dropdown-toggle click, 不受 iOS Safari display: none 静默忽略限制
    $controls.trigger('shown.bs.dropdown');
    // r.12.h.6 (辉哥 08:42 Puppeteer r.12.h.5 fail, controls hasOpen=false 800ms 后):
    //   vendor Dropdown L77 'shown.bs.dropdown' listener 内部调 m.redraw() 排 rAF (mithril 2.3.1),
    //   rAF 在 Puppeteer headless chromium / iOS Safari 异步 context 里可能 delay > 1s (实测 800ms
    //   内 mithril redraw 没跑, vendor Dropdown view 拿 stale this.showing=false, 'open' className
    //   不加). Bootstrap dropdown toggle.click() 流程 work 是因为 Bootstrap 内部 force sync 跑
    //   mithril redraw, 但 ziven-core jQuery trigger 跳过了 Bootstrap 流程
    // 修法: 调 m.redraw.sync() 强制 mithril sync redraw, vendor Dropdown view 立即跑 this.showing=true
    //   加 'open' className + mithril 红渲 CSS transition 滑上来 menu
    // 实战教训: vendor 内部 m.redraw() 排 rAF 在异步 context 不可靠, ziven-core 主动触发时必须 sync
    // 适用: 任何 ziven 扩展跟 vendor 异步 mithril redraw 交互场景
    if (typeof m !== 'undefined' && typeof m.redraw === 'function') {
      try {
        m.redraw.sync();
      } catch (err) {/* ignore if mithril not yet mounted */}
    } else if (typeof window !== 'undefined' && window.m && typeof window.m.redraw === 'function') {
      try {
        window.m.redraw.sync();
      } catch (err) {/* ignore */}
    }
  });

  // reaction summary 注入 (渲染所有 entries)
  // (Mavis Worker 9/21 20:55 Fix A 二次修补, 辉哥 9/21 20:40 拍板):
  //   改 jsx 没用, 因为 modifyDiscussionItem.js 走 setInterval + jQuery inline HTML,
  //   不 import JSX 组件. 实际 reaction summary 渲染在这段. Fix A 必须改这里.
  //   配合 ziven-reactions/extend.php DiscussionResource fields 直接 expose reactionCounts
  //   (从 first_post_id 聚合 PostReaction). ziven-core 改读 discussion.reactionCounts() 优先,
  //   fallback discussion.attribute('reactionCounts') (Flarum Model 默认 reader, 不依赖
  //   ziven-reactions JS bundle), 最后 fallback firstPost.reactionCounts() (老版完全兼容).
  //   根因 (Mavis Worker 9/21 20:32 调查): Flarum 2.0 addDefaultInclude 是 fallback 语义,
  //   客户端带 include 参数时服务端忽略 defaultInclude → /all DiscussionListPage 客户端默认带
  //   include=user,lastPostedUser,tags,tags.parent → 服务端 included 数组没 posts 类型 →
  //   discussion.firstPost() 返 null → 这里 {firstPost ? ... : null} 走 null 分支 → 视觉空白.
  let reactionCounts = null;
  // 1) ziven-reactions 注册的 method (extend.ts .attribute('reactionCounts') 生效时)
  if (typeof discussion.reactionCounts === 'function') {
    reactionCounts = discussion.reactionCounts();
  }
  // 2) Flarum Model 默认 reader (ziven-reactions 后端 extend.php expose 但 JS bundle 未加载时)
  if ((!reactionCounts || Object.keys(reactionCounts).length === 0) && typeof discussion.attribute === 'function') {
    reactionCounts = discussion.attribute('reactionCounts');
  }
  // 3) 老版 firstPost (完全兼容, 防御式)
  if (!reactionCounts || Object.keys(reactionCounts).length === 0) {
    const firstPost = discussion.firstPost();
    if (firstPost && typeof firstPost.reactionCounts === 'function') {
      reactionCounts = firstPost.reactionCounts();
    }
  }
  if (reactionCounts) {
    const entries = Object.keys(reactionCounts || {}).map(function (id) {
      const reaction = app.store.getById('reactions', id);
      if (!reaction) return null;
      const count = reactionCounts[id];
      if (!count || count === 0) return null;
      return {
        reaction: reaction,
        count: count
      };
    }).filter(Boolean);
    if (entries.length > 0) {
      const totalCount = entries.reduce(function (s, e) {
        return s + e.count;
      }, 0);
      if (totalCount > 0) {
        const $summaryWrap = discussionContainer.find('.itemReply .ziven-core-discussion-reaction-summary');
        const REACTION_TWEMOJI_MOBILE = {
          thumbsup: {
            codepoint: '1f44d',
            unicode: '\ud83d\udc4d'
          },
          thumbsdown: {
            codepoint: '1f44e',
            unicode: '\ud83d\udc4e'
          },
          laughing: {
            codepoint: '1f606',
            unicode: '\ud83d\ude06'
          },
          confused: {
            codepoint: '1f615',
            unicode: '\ud83d\ude15'
          },
          heart: {
            codepoint: '2764',
            unicode: '\u2764'
          },
          tada: {
            codepoint: '1f389',
            unicode: '\ud83c\udf89'
          }
        };
        const TWEMOJI_CDN_MOBILE = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/16.0.1/72x72/';
        let html = '';
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];
          const identifier = entry.reaction.identifier();
          const display = entry.reaction.display() || identifier;
          if (entry.reaction.type() === 'icon') {
            html += '<span class="ziven-core-discussion-reaction-entry"><i class="ziven-core-discussion-reaction-emoji ' + identifier + '" data-reaction="' + identifier + '" aria-hidden="true" title="' + display + '"></i></span>';
          } else {
            const meta = REACTION_TWEMOJI_MOBILE[identifier];
            if (meta && meta.codepoint) {
              html += '<span class="ziven-core-discussion-reaction-entry"><img class="ziven-core-discussion-reaction-emoji emoji" src="' + TWEMOJI_CDN_MOBILE + meta.codepoint + '.png" alt="' + display + '" title="' + display + '" data-reaction="' + identifier + '" draggable="false" loading="lazy" /></span>';
            } else {
              html += '<span class="ziven-core-discussion-reaction-entry"><span class="ziven-core-discussion-reaction-emoji" data-reaction="' + identifier + '" title="' + display + '">' + (meta ? meta.unicode : display) + '</span></span>';
            }
          }
        }
        html += '<span class="ziven-core-discussion-reaction-total">' + totalCount + '</span>';
        $summaryWrap.attr('data-count', totalCount).html(html);
      }
    }
  }

  // subscription / bookmark state 同步
  const itemStateBadges = discussionContainer.find('.itemStateBadges');
  let lastSubscribed = null;
  let lastBookmarked = null;
  const stateTask = setInterval(function () {
    if (!document.body.contains(discussionContainer[0])) {
      clearInterval(stateTask);
      return;
    }
    const subscription = discussion.subscription && discussion.subscription();
    const subscribed = subscription === 'follow' || subscription === 'lurk';
    const bookmarked = !!(discussion.bookmarked && discussion.bookmarked());
    if (subscribed !== lastSubscribed || bookmarked !== lastBookmarked) {
      lastSubscribed = subscribed;
      lastBookmarked = bookmarked;
      // (辉哥 9/10 20:14 反馈 "只有已关注才显示关注图标, 已收藏才显示收藏图标"):
      //   之前默认两个 icon 都 display:flex, 改成根据 active 状态动态 append/remove
      //   槽位顺序: 订阅先 (left), 收藏后 (right, 紧贴评论 💬 左侧)
      //   - 都 active: [⭐] [🔖] [💬]
      //   - 只订阅: [⭐] [💬] (订阅 icon 紧贴评论, 等于在收藏槽位置)
      //   - 只收藏: [🔖] [💬] (收藏 icon 紧贴评论)
      //   - 都不: [] [💬] (空槽, 视觉一致)
      itemStateBadges.empty();
      if (subscribed) {
        itemStateBadges.append('<i class="fa-solid fa-star itemStateSubscribe active" title="订阅"></i>');
      }
      if (bookmarked) {
        itemStateBadges.append('<i class="fa-solid fa-bookmark itemStateBookmark active" title="收藏"></i>');
      }
    }
  }, 200);
  const initSubscription = discussion.subscription && discussion.subscription();
  const initSubscribed = initSubscription === 'follow' || initSubscription === 'lurk';
  const initBookmarked = !!(discussion.bookmarked && discussion.bookmarked());
  // 初始就触发一次 update 走逻辑
  if (initSubscribed || initBookmarked) {
    itemStateBadges.empty();
    if (initSubscribed) {
      itemStateBadges.append('<i class="fa-solid fa-star itemStateSubscribe active" title="订阅"></i>');
    }
    if (initBookmarked) {
      itemStateBadges.append('<i class="fa-solid fa-bookmark itemStateBookmark active" title="收藏"></i>');
    }
  }
}